import React, { useEffect, Fragment, memo, useState } from "react";
import {
  Navbar,
  Container,
  Nav,
  Dropdown,
  Modal,
  Button,
  Badge,
} from "react-bootstrap";
import { FaBell, FaTrash } from "react-icons/fa";
import { Link } from "react-router-dom";
import CustomToggle from "../../../dropdowns";
import {
  getAllNotifications,
  markNotificationAsRead,
  deleteNotification,
} from "../../../../services/notificationService";

import shapes1 from "../../../../assets/images/shapes/01.png";
import shapes2 from "../../../../assets/images/shapes/02.png";
import shapes3 from "../../../../assets/images/shapes/03.png";
import shapes4 from "../../../../assets/images/shapes/04.png";
import shapes5 from "../../../../assets/images/shapes/05.png";
import avatars1 from "../../../../assets/images/avatars/01.png";
import avatars2 from "../../../../assets/images/avatars/avtar_1.png";
import avatars3 from "../../../../assets/images/avatars/avtar_2.png";
import avatars4 from "../../../../assets/images/avatars/avtar_3.png";
import avatars5 from "../../../../assets/images/avatars/avtar_4.png";
import avatars6 from "../../../../assets/images/avatars/avtar_5.png";
import Logo from "../../components/logo";

// Redux Selector / Action
import { useSelector } from "react-redux";
import * as SettingSelector from "../../../../store/setting/selectors";
import { updateAdminUser } from "../../../../services/service";

const Header = memo((props) => {
  const navbarHide = useSelector(SettingSelector.navbar_show);
  const headerNavbar = useSelector(SettingSelector.header_navbar);
  const userData = JSON.parse(localStorage.getItem("user"));
  const userName = userData?.user?.name || "Guest";
  const profileImage = userData?.user?.profilePic || avatars1;
  const userRole = userData?.user?.role || "N/A";
  const userEmail = userData?.user?.email || "N/A";
  const userLocation = userData?.user?.location || "Not Available";
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [selectedNotification, setSelectedNotification] = useState(null);
  const [profileData, setProfileData] = useState({
    name: userName,
    email: userEmail,
    image: null,
    preview: profileImage,
    removed: false,
  });
  const handleChange = (e) => {
    setProfileData({
      ...profileData,
      [e.target.name]: e.target.value,
    });
  };
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setProfileData({
      ...profileData,
      image: file,
      preview: URL.createObjectURL(file),
      removed: false,
    });
  };
  const handleSaveProfile = async () => {
    try {
      const formData = new FormData();
      formData.append("name", profileData.name);
      if (profileData.image) {
        formData.append("image", profileData.image);
      }
      const res = await updateAdminUser(userData?.user?.id, formData);
      if (res && res.user) {
        // Update local storage
        const updatedUser = JSON.parse(localStorage.getItem("user"));
        updatedUser.user.name = res.user.name;
        updatedUser.user.profilePic = res.user.profilePic;
        localStorage.setItem("user", JSON.stringify(updatedUser));

        window.location.reload();
      }
    } catch (err) {
      console.log(err);
    }
  };

  // ✅ Helper to safely extract text
  const getLocalizedText = (field) => {
    if (!field) return "";
    if (typeof field === "string") return field;
    if (typeof field === "object") return field.en || field.hi || "";
    return "";
  };

  // ✅ Fetch all notifications (read + unread)
  const fetchNotifications = async () => {
    try {
      const res = await getAllNotifications();
      if (res?.success) {
        const allNotifs = res.data || [];
        setNotifications(allNotifs);
        setUnreadCount(
          res.unreadCount ||
            allNotifs.filter((n) => n.status === "unread").length
        );
      }
    } catch (err) {
      console.error("❌ Error fetching notifications:", err);
    } finally {
      setLoading(false);
    }
  };

  // ✅ Mark as read (but keep visible)
  const handleMarkAsRead = async (notif) => {
    try {
      if (notif.status === "unread") {
        const res = await markNotificationAsRead(notif._id);
        if (res?.success) {
          setNotifications((prev) =>
            prev.map((n) =>
              n._id === notif._id ? { ...n, status: "read" } : n
            )
          );
          setUnreadCount((prev) => Math.max(prev - 1, 0));
        }
      }
      setSelectedNotification(notif);
      setShowMessageModal(true);
    } catch (err) {
      console.error("❌ Error marking notification as read:", err);
    }
  };

  // ✅ Delete notification
  const handleDeleteNotification = async (id) => {
    try {
      const res = await deleteNotification(id);
      if (res?.success) {
        setNotifications((prev) => prev.filter((n) => n._id !== id));
      }
    } catch (err) {
      console.error("❌ Error deleting notification:", err);
    }
  };

  // 🔁 Auto-refresh notifications every 10 min
  useEffect(() => {
    fetchNotifications();
    const interval = setInterval(fetchNotifications, 10 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (headerNavbar === "navs-sticky" || headerNavbar === "nav-glass") {
      window.onscroll = () => {
        if (document.documentElement.scrollTop > 50) {
          document.getElementsByTagName("nav")[0].classList.add("menu-sticky");
        } else {
          document
            .getElementsByTagName("nav")[0]
            .classList.remove("menu-sticky");
        }
      };
    }
  });

  const minisidebar = () => {
    document.getElementsByTagName("ASIDE")[0].classList.toggle("sidebar-mini");
  };

  const [currentPage, setCurrentPage] = useState(1);
  const notificationsPerPage = 12;

  // Pagination
  const totalPages = Math.ceil(notifications.length / notificationsPerPage);
  const indexOfLast = currentPage * notificationsPerPage;
  const indexOfFirst = indexOfLast - notificationsPerPage;
  const currentNotifications = notifications.slice(indexOfFirst, indexOfLast);

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };
  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  return (
    <Fragment>
      <Navbar
        expand="lg"
        variant="light"
        className={`nav iq-navbar ${headerNavbar} ${navbarHide.join(" ")}`}
      >
        <Container fluid className="navbar-inner">
          <Link to="/dashboard" className="navbar-brand">
            <Logo color={true} />
            <h4 className="logo-title">Agrirent</h4>
          </Link>

          <div className="sidebar-toggle" onClick={minisidebar}>
            <i className="icon">
              <svg width="20px" height="20px" viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z"
                />
              </svg>
            </i>
          </div>

          <Navbar.Toggle aria-controls="navbarSupportedContent">
            <span className="navbar-toggler-icon">
              <span className="mt-2 navbar-toggler-bar bar1"></span>
              <span className="navbar-toggler-bar bar2"></span>
              <span className="navbar-toggler-bar bar3"></span>
            </span>
          </Navbar.Toggle>

          <Navbar.Collapse id="navbarSupportedContent">
            <Nav
              as="ul"
              className="mb-2 ms-auto navbar-list mb-lg-0 align-items-center"
            >
              {/* 🔔 Notification Dropdown */}
              <Dropdown align="end">
                <Dropdown.Toggle
                  variant="light"
                  id="notification-drop"
                  className="position-relative border-0 bg-transparent shadow-none"
                  style={{ padding: "5px" }}
                >
                  <FaBell size={22} className="text-primary" />
                  {unreadCount > 0 && (
                    <Badge
                      bg="danger"
                      pill
                      className="position-absolute start-10 translate-middle"
                      style={{ fontSize: "0.7rem", top: "0px" }}
                    >
                      {unreadCount}
                    </Badge>
                  )}
                </Dropdown.Toggle>

                <Dropdown.Menu
                  className="p-0 sub-drop dropdown-menu-end"
                  aria-labelledby="notification-drop"
                  style={{ width: "380px" }}
                >
                  <div className="m-0 shadow-none card">
                    <div className="py-3 card-header d-flex justify-content-between bg-primary">
                      <h5 className="mb-0 text-white">Notifications</h5>
                    </div>

                    <div
                      className="p-0 card-body"
                      style={{ maxHeight: "400px", overflowY: "auto" }}
                    >
                      {loading ? (
                        <p className="text-center py-3">Loading...</p>
                      ) : notifications.length === 0 ? (
                        <p className="text-center py-3">No notifications</p>
                      ) : (
                        currentNotifications.map((notif, index) => (
                          <div
                            key={notif._id}
                            className={`iq-sub-card d-flex align-items-start justify-content-between ${
                              notif.status === "unread" ? "bg-light" : ""
                            }`}
                            style={{
                              cursor: "default",
                              padding: "10px 12px",
                              borderBottom: "1px solid #eee",
                            }}
                          >
                            <div
                              className="d-flex align-items-start flex-grow-1"
                              onClick={() => handleMarkAsRead(notif)}
                              style={{ cursor: "pointer" }}
                            >
                              <img
                                className="p-1 avatar-40 rounded-pill bg-soft-primary"
                                src={
                                  [shapes1, shapes2, shapes3, shapes4][
                                    (indexOfFirst + index) % 4
                                  ]
                                }
                                alt=""
                              />
                              <div className="ms-3 flex-grow-1">
                                <h6 className="mb-0 fw-bold">
                                  {getLocalizedText(notif.title) ||
                                    "Notification"}
                                </h6>
                                <p
                                  className="mb-0 text-wrap text-muted"
                                  style={{
                                    whiteSpace: "normal",
                                    maxWidth: "230px",
                                    fontSize: "13px",
                                  }}
                                >
                                  {getLocalizedText(notif.message) ||
                                    "No message"}
                                </p>
                                <small
                                  className="text-muted d-block"
                                  style={{ fontSize: "11px" }}
                                >
                                  {new Date(notif.createdAt).toLocaleString(
                                    "en-IN",
                                    {
                                      year: "numeric",
                                      month: "short",
                                      day: "2-digit",
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      hour12: true,
                                    }
                                  )}
                                </small>
                              </div>
                            </div>

                            <FaTrash
                              size={16}
                              color="#dc3545"
                              className="ms-2"
                              style={{
                                cursor: "pointer",
                                flexShrink: 0,
                                marginTop: "10px",
                                transition: "0.2s",
                              }}
                              onClick={() =>
                                handleDeleteNotification(notif._id)
                              }
                              title="Delete notification"
                            />
                          </div>
                        ))
                      )}
                      {notifications.length > notificationsPerPage && (
                        <div className="d-flex justify-content-between align-items-center p-2 border-top bg-light">
                          <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={handlePrevPage}
                            disabled={currentPage === 1}
                          >
                            Previous
                          </Button>
                          <span className="small text-muted">
                            Page {currentPage} of {totalPages}
                          </span>
                          <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={handleNextPage}
                            disabled={currentPage === totalPages}
                          >
                            Next
                          </Button>
                        </div>
                      )}
                    </div>
                  </div>
                </Dropdown.Menu>
              </Dropdown>

              {/* 👤 User Profile Dropdown */}
              <Dropdown align="end" className="ms-2">
                <Dropdown.Toggle
                  as={CustomToggle}
                  variant="nav-link py-0 d-flex align-items-center"
                  href="#"
                  id="navbarDropdown"
                >
                  <img
                    src={profileImage}
                    alt="User-Profile"
                    className="theme-color-default-img img-fluid avatar avatar-50 avatar-rounded"
                  />
                  {/* <img
                    src={avatars2}
                    alt="User-Profile"
                    className="theme-color-purple-img img-fluid avatar avatar-50 avatar-rounded"
                  />
                  <img
                    src={avatars3}
                    alt="User-Profile"
                    className="theme-color-blue-img img-fluid avatar avatar-50 avatar-rounded"
                  />
                  <img
                    src={avatars4}
                    alt="User-Profile"
                    className="theme-color-green-img img-fluid avatar avatar-50 avatar-rounded"
                  />
                  <img
                    src={avatars5}
                    alt="User-Profile"
                    className="theme-color-yellow-img img-fluid avatar avatar-50 avatar-rounded"
                  />
                  <img
                    src={avatars6}
                    alt="User-Profile"
                    className="theme-color-pink-img img-fluid avatar avatar-50 avatar-rounded"
                  /> */}
                  <div className="caption ms-3 d-none d-md-block">
                    <h6 className="mb-0 caption-title">{userName}</h6>
                    <p
                      className="mb-0 text-muted"
                      style={{ fontSize: "0.75rem" }}
                    >
                      {userRole}
                    </p>
                  </div>
                </Dropdown.Toggle>

                <Dropdown.Menu
                  className="p-0 sub-drop dropdown-menu-end"
                  aria-labelledby="navbarDropdown"
                >
                  <div className="m-0 shadow-none card">
                    <div className="py-3 card-header d-flex justify-content-between bg-primary">
                      <h5 className="mb-0 text-white">User Profile</h5>
                    </div>

                    <div className="p-0 card-body">
                      <div className="text-center mb-3">
                        <img
                          src={profileImage}
                          className="p-1 bg-soft-primary rounded-circle avatar-80 img-fluid"
                          alt="user"
                        />
                        <h6 className="mt-2 mb-0">{userName}</h6>
                        <small className="text-muted">{userEmail}</small>
                      </div>

                      <div className="px-3 pb-3">
                        <Dropdown.Divider />

                        <Dropdown.Item
                          className="d-flex align-items-center text-success"
                          onClick={() => setShowProfileModal(true)}
                        >
                          <i class="ri-user-line me-2"></i> Profile
                        </Dropdown.Item>

                        <Dropdown.Divider />

                        <Dropdown.Item
                          onClick={() => {
                            localStorage.clear();
                            window.location.href = "/";
                          }}
                          className="d-flex align-items-center text-danger"
                        >
                          <i className="ri-logout-box-r-line me-2"></i> Logout
                        </Dropdown.Item>
                      </div>
                    </div>
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            </Nav>
          </Navbar.Collapse>

          {/* 🔹 Full Message Modal */}
          <Modal
            show={showMessageModal}
            onHide={() => setShowMessageModal(false)}
            centered
            size="md"
          >
            <Modal.Header closeButton className="bg-secondary">
              <Modal.Title className="text-white">
                {getLocalizedText(selectedNotification?.title)}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ whiteSpace: "pre-wrap" }}>
              {getLocalizedText(selectedNotification?.message)}
              <br />
              <br />
              <small className="text-muted">
                {selectedNotification &&
                  new Date(selectedNotification.createdAt).toLocaleString(
                    "en-IN",
                    {
                      year: "numeric",
                      month: "short",
                      day: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    }
                  )}
              </small>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => setShowMessageModal(false)}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal
            show={showProfileModal}
            onHide={() => {
              setShowProfileModal(false);
              setProfileData({
                ...profileData,
                preview: userData?.user?.profilePic || avatars1,
              });
            }}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Edit Profile</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div className="text-center mb-3">
                <img
                  src={profileData.preview}
                  className="rounded-circle"
                  style={{ width: 100, height: 100, objectFit: "cover" }}
                  alt="profile"
                />

                <div className="mt-2 d-flex justify-content-center gap-2">
                  <Button variant="outline-primary" size="sm">
                    <label htmlFor="profileImg" style={{ cursor: "pointer" }}>
                      Change Image
                    </label>
                  </Button>

                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => {
                      setProfileData({
                        ...profileData,
                        image: null, // file clear
                        preview: avatars1, // default image
                        removed: true, // only frontend remove flag
                      });
                    }}
                  >
                    Remove Image
                  </Button>

                  <input
                    type="file"
                    id="profileImg"
                    className="d-none"
                    onChange={handleImageChange}
                  />
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  name="name"
                  value={profileData.name}
                  className="form-control"
                  onChange={handleChange}
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Email</label>
                <input
                  type="text"
                  className="form-control"
                  value={profileData.email}
                  disabled
                />
              </div>
            </Modal.Body>

            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => {
                  setShowProfileModal(false);
                  setProfileData({
                    ...profileData,
                    preview: userData?.user?.profilePic || avatars1,
                  });
                }}
              >
                Cancel
              </Button>
              <Button variant="primary" onClick={handleSaveProfile}>
                Save
              </Button>
            </Modal.Footer>
          </Modal>
        </Container>
      </Navbar>
    </Fragment>
  );
});

export default Header;
